
<template>
  <div>
    <dialog-create-task @cancel="handleCancel" @done="handleDone"></dialog-create-task>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import DialogCreateTask from '../../components/tasks/control/DialogCreateTask.vue'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'NewTaskPage',
  //mixins: [ validations ],
  components: {
    DialogCreateTask
    //ComponentName: () => import(''),
  },
  data() {
    return {
      
    }
  },
  methods: {
    handleCancel() {
      this.$router.go(-1)
    },
    handleDone(){
      this.$router.go(-1)
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>